export default "__VITE_ASSET__CLjNdJYV__"